import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableBatchPrescreenStart = loadable(
  () => import('./BatchPrescreenStart'),
  { fallback: <LoadingScreen /> },
);

export default LoadableBatchPrescreenStart;
